import { render, staticRenderFns } from "./DestroyApplier.vue?vue&type=template&id=4f74e66f"
import script from "./DestroyApplier.vue?vue&type=script&lang=js"
export * from "./DestroyApplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports